/** Dark-only Mantine theme: deep neutral surfaces, one restrained accent. */

import { Badge, Card, createTheme, type MantineColorsTuple } from '@mantine/core';

const brand: MantineColorsTuple = [
  '#eef1ff',
  '#dde0f4',
  '#b7bee4',
  '#8f99d5',
  '#6d7ac9',
  '#5865c2',
  '#4b5abd',
  '#3c4aa7',
  '#344195',
  '#2a3783',
];

/** Near-black neutrals: 0 is the lightest text, 9 the darkest background. */
const dark: MantineColorsTuple = [
  '#c9cad3',
  '#a7a8b4',
  '#8a8b98',
  '#6d6e7c',
  '#4c4d59',
  '#35363f',
  '#26272e',
  '#1b1c21',
  '#141519',
  '#0d0e11',
];

/** Semantic accents for the two directions money can move. */
export const KIND_COLOR = {
  deposit: 'teal',
  withdrawal: 'red',
} as const;

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: { dark: 5 },
  defaultRadius: 'md',
  colors: { brand, dark },
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  fontFamilyMonospace: 'ui-monospace, SFMono-Regular, "JetBrains Mono", Menlo, monospace',
  headings: {
    fontWeight: '600',
  },
  components: {
    Card: Card.extend({
      defaultProps: { withBorder: true, padding: 'lg', radius: 'md' },
    }),
    Badge: Badge.extend({
      defaultProps: { variant: 'light', radius: 'sm' },
    }),
  },
});
